import React, {useContext, useState, ReactNode} from "react";

interface MenuContextValue {
  menuInit: (menuText: string, showBack: boolean) => void;
  menuText: string;
  showBack: boolean;
}

const MenuContext = React.createContext<MenuContextValue>({ undefined } as unknown as MenuContextValue);

export function useMenu() {
  return useContext(MenuContext);
}

export function MenuProvider({ children }: { children: ReactNode }) {
  const [menuText, setMenuText] = useState("");
  const [showBack, setShowBack] = useState(false);


  const menuInit = (menuText: string, showBack: boolean) => {
    setMenuText(menuText);
    setShowBack(showBack);
  }

  const value: MenuContextValue = {
    menuInit,
    menuText,
    showBack,
  };

  return (
      <MenuContext.Provider value={value}>
        {children}
      </MenuContext.Provider>
  );
}
